<template>
  <div class="max-w-2lg mx-auto p-6 bg-white rounded-lg items-center" style="background: radial-gradient(circle at 50% -50%, #dff9f0, #dff9f0, #e0f9f0, #e2faf1, #e5faf3, #ebfbf6, #f3fdf9, #f9fefc, #fcfffe, #feffff, #ffffff, #ffffff);">
    <div class="max-w-lg  mx-auto py-16">
   <h2 class="text-2xl font-semibold text-center mb-4">Bekleme Listesine Katıl</h2>
    <p class="text-gray-600 text-center mb-4">E-posta adresinizi girerek erken erişim kazanın!</p>

    <form @submit.prevent="submitForm" class="space-y-4">
      <input
        type="email"
        v-model="email"
        required
        placeholder="E-posta adresiniz"
        class="w-full p-3 border rounded-full focus:ring focus:ring-blue-200"
      />

      <button
        type="submit"
        class="w-full rounded-full bg-secondary px-3.5 py-2 font-semibold text-primary shadow-sm
           hover:bg-teal-50 hover:text-secondary hover:border-secondary hover:ring-4 hover:ring-secondary
           focus:ring-4 focus:outline-none focus:ring-secondary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900"
        :disabled="loading"
      >
        {{ loading ? 'Gönderiliyor...' : 'Bekleme Listesine Katıl' }}
      </button>

      <p v-if="message" :class="{'text-green-600': success, 'text-red-600': !success}" class="text-center mt-2">
        {{ message }}
      </p>
    </form>
  </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import axios from 'axios';

export default defineComponent({
  name: 'WaitListForm',
  setup() {

    const email = ref<string>("");
    const loading = ref<boolean>(false);
    const message = ref<string>("");
    const success = ref<boolean>(false);
    // Dummy data
    // API İsteğini yapan fonksiyon
    const submitForm = async () => {
      if (!email.value) {
        message.value = "Lütfen geçerli bir e-posta girin.";
        success.value = false;
        return;
      }

      loading.value = true;
      message.value = "";

      try {
        const response = await axios.post(
          "https://api.brevo.com/v3/contacts/lists/8/contacts/add",
          {
            emails: [email.value],
          //  listIds: [8], // 📌 Brevo'da oluşturduğunuz LIST ID'yi buraya yazın!
          },
          {
            headers: {
              "Content-Type": "application/json",
              "api-key": "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", // 📌 Buraya kendi Brevo API Key'inizi ekleyin!
            },
          }
        );

        message.value = "Başarıyla bekleme listesine katıldınız! 🎉";
        success.value = true;
        email.value = "";
      } catch (error: any) {
        message.value =
          error.response?.data?.message || "Bir hata oluştu. Lütfen tekrar deneyin.";
        success.value = false;
      } finally {
        loading.value = false;
      }
    };

    return {
      email,
      loading,
      message,
      success,
      submitForm,
    };
  }
});
</script>

<style scoped>

</style>